import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import View from './View';
import EditSchema from './EditSchema';
import ColorSelectWidget from '../CTASection/ColorSelectWidget';
import { useIntl } from 'react-intl';
import messages from '../../../../messages';

const StatisticsEdit = (props) => {
  const { selected, data, block, onChangeBlock } = props;
  const schema = EditSchema(props);

  const handleFieldChange = (id, value) => {
    onChangeBlock(block, { ...data, [id]: value });
  };

  const intl = useIntl();

  return (
    <>
      <div className="block fcmh-statistics">
        <View {...props} mode="edit" />
      </div>

      <SidebarPortal selected={selected}>
        <div className="fcmh-editform">
          <div className="field">
            <label>{schema.properties.title.title}</label>
            <input
              type="text"
              value={data.title || ''}
              onChange={(e) => handleFieldChange('title', e.target.value)}
              placeholder="Titel eingeben…"
            />
          </div>

          <div className="field">
            <label>{schema.properties.columns.title}</label>
            <select
              value={data.columns || 'four'}
              onChange={(e) => handleFieldChange('columns', e.target.value)}
            >
              <option value="two">2</option>
              <option value="three">3</option>
              <option value="four">4</option>
            </select>
          </div>

          <div className="field">
            <label>{schema.properties.align.title}</label>
            <select
              value={data.align || 'left'}
              onChange={(e) => handleFieldChange('align', e.target.value)}
            >
              <option value="left">
                {intl.formatMessage(messages.statisticsAlignmentLeft)}
              </option>
              <option value="center">
                {intl.formatMessage(messages.statisticsAlignmentCenter)}
              </option>
              <option value="right">
                {intl.formatMessage(messages.statisticsAlignmentRight)}
              </option>
            </select>
          </div>

          <div className="field checkbox">
            <label>
              <input
                type="checkbox"
                checked={!!data.showAnimation}
                onChange={(e) =>
                  handleFieldChange('showAnimation', e.target.checked)
                }
              />
              {intl.formatMessage(messages.statisticsAnimation)}
            </label>
          </div>

          <div className="field">
            <label>{schema.properties.color.title}</label>
            <ColorSelectWidget
              id="color"
              value={data.color || 'blue'}
              onChange={(id, value) => handleFieldChange(id, value)}
            />
          </div>

          <div className="field checkbox">
            <label>
              <input
                type="checkbox"
                checked={!!data.setFullWidth}
                onChange={(e) =>
                  handleFieldChange('setFullWidth', e.target.checked)
                }
              />
              {intl.formatMessage(messages.fullWidth)}
            </label>
          </div>

          <div className="fcmh-statistics-edit-items">
            <div className="fcmh-statistics-edit-header">
              <h4>{intl.formatMessage(messages.statisticsElement)}</h4>
              <button
                type="button"
                className="add-btn"
                onClick={() => {
                  const newStat = { value: '', label: '', info: '' };
                  handleFieldChange('stats', [...(data.stats || []), newStat]);
                }}
              >
                {intl.formatMessage(messages.statisticsElementAdd)}
              </button>
            </div>

            {(data.stats || []).map((stat, i) => (
              <div key={i} className="fcmh-statistics-item">
                <div className="field">
                  <label>
                    {intl.formatMessage(messages.statisticsElementValue)}
                  </label>
                  <input
                    type="text"
                    value={stat.value || ''}
                    onChange={(e) => {
                      const newStats = [...data.stats];
                      newStats[i].value = e.target.value;
                      handleFieldChange('stats', newStats);
                    }}
                  />
                </div>
                <div className="field">
                  <label>Label</label>
                  <input
                    type="text"
                    value={stat.label || ''}
                    onChange={(e) => {
                      const newStats = [...data.stats];
                      newStats[i].label = e.target.value;
                      handleFieldChange('stats', newStats);
                    }}
                  />
                </div>
                <div className="field">
                  <label>
                    {intl.formatMessage(messages.statisticsElementInfo)}
                  </label>
                  <input
                    type="text"
                    value={stat.info || ''}
                    onChange={(e) => {
                      const newStats = [...data.stats];
                      newStats[i].info = e.target.value;
                      handleFieldChange('stats', newStats);
                    }}
                  />
                </div>
                <button
                  type="button"
                  className="remove-btn"
                  onClick={() => {
                    const newStats = [...data.stats];
                    newStats.splice(i, 1);
                    handleFieldChange('stats', newStats);
                  }}
                >
                  {intl.formatMessage(messages.statisticsElementRemove)}
                </button>
              </div>
            ))}
          </div>
        </div>
      </SidebarPortal>
    </>
  );
};

export default StatisticsEdit;
